var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWohnungActive = function SvgWohnungActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#656565",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.093 15.415h43.813V55.5H6.093z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.364 16.348 13.351.499h29.298l10.987 15.849"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.093 15.415v13.982h43.813V15.415H6.093zm17.712 10.254H13.551v-6.525h10.254v6.525zm18.644 0H32.195v-6.525h10.254v6.525z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.906 24.737h3.729v4.66h-3.729z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.906 22.873h3.729v1.864h-3.729z"
  }))));
};
export default SvgWohnungActive;